require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-4-limitations-of-the-shopify-platform-with-suggested-solutions.json") })
        }
      }, "path---blog-4-limitations-of-the-shopify-platform-with-suggested-solutions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-4-limitations-of-the-shopify-platform-with-suggested-solutions!./.cache/json/blog-4-limitations-of-the-shopify-platform-with-suggested-solutions.json
// module id = 395
// module chunks = 231608221292675